import {
  GET_VEHICLE_DROPDOWN_OPTIONS,
  CREATE_VEHICLE_TRACKING_OUTWARD,
  CREATE_DUPLICATE_VEHICLE_TRACKING,
  GET_DELIVERY_FOR_BUSINESS_PARTNER,
  GET_DELIVERY_DROPDOWN_OPTIONS,
  RESET_DELIVERY_LIST_FOR_VEHICLE_NUMBER,
  RESET_VEHICLE_DROPDOWN_OPTIONS,
  GET_CATEGORY_BASED_BUSINESS_PARTNER,
  GET_TRANSPORTER_DATA,
  GET_TRANSPORTER_DROPDOWN_OPTIONS,
  GET_ATTACHED_DELIVERY_FOR_OUTWARD_VEHICLE,
  RESET_ATTACHED_DELIVERY_FOR_OUTWARD_VEHICLE,
  GET_VEHICLE_DETAILS_FOR_OUTWARD,
  GET_VEHICLE_TRACKINGS_FOR_VEHICLE_DETAIL,
  RESET_VEHICLE_DETAILS,
  GET_VEHICLE_TRACKING_LIST_FOR_PLANNING,
  GET_OUTWARD_VEHICLE_TRACKING_DETAILS,
  UPDATE_VEHICLE_TRACKING_FOR_OUTWARD,
  RESET_DELIVERY_FOR_BUSINESS_PARTNER,
  RESET_OUTWARD_VEHICLE_TRACKING_DETAILS,
  GET_PACK_TYPE_FOR_DELIVERY_LINE_ITEM,
  CREATE_VEHICLE_TRACKING_LOAD_HEADER,
  GET_VEHICLE_TRACKING_ATTACHED_LOADS,
  GET_LOAD_LINE_ITEMS_FOR_LOAD_HEADER,
  UPDATE_VEHICLE_TRACKING_LOAD_LINE_ITEM,
  UPDATE_VEHICLE_TRACKING_LOAD,
  GET_DATA_FOR_VEHICLE_TRACKING_LOAD_CARDS,
  GET_CAPTURED_WEIGHT_FOR_WEIGHT_BRIDGE_EVENT_UUID,
  UPDATE_VEHICLE_TRACKING_LOAD_WEIGHT,
  GET_LOAD_LINE_ITEMS_FOR_VEHICLE_TRACKING,
  CONFIRM_VEHICLE_TRACKING_LOAD,
  UPDATE_VEHICLE_TRACKING_ON_HOLD,
  VALIDATE_AND_GET_DUPLICATE_OBJECTS_FOR_VEHICLE_TRACKING,
  GET_ATTACHED_DELIVERIES_FOR_VEHICLE_TRACKING,
  UPDATE_VEHICLE_TRACKING_DELIVERY_ATTACHMENTS,
  GET_PRODUCTS,
  RESET_GET_PACK_TYPE_FOR_DELIVERY_LINE_ITEM,
  GET_OUTWARD_REPORT_WITH_EXIT_TIME,
  GET_ATTACHED_DELIVERY_LINE_ITEMS_FOR_VEHICLE_TRACKING,
  UPDATE_VEHICLE_TRACKING_DETAILS,
  GET_VARIANCE_REPORT_FOR_OUTWARD,
  UPDATE_VEHICLE_TRACKING_STATUS,
  GET_REASONS_DROPDOWN_OPTIONS_FOR_VEHICLE_TRACKING,
} from 'src/redux/Actions/Type';

const initialState = {
  vehicleDropdownOptions: [],
  createOutward: {},
  createDuplicateVehicleTracking: {},
  deliveryLineitemData: {},
  deliveryDropdownOptions: null,
  categoryBasedBusinessPartner: [],
  transporterList: [],
  transporterDropdownOptions: [],
  attachedDeliveryForOutwardVehicle: [],
  vehicleDetailsForOutward: {},
  vehicleTrackingsForVehicleDetail: {},
  vehicleTrackingListForPlanning: {},
  outwardVehicleTrackingDetails: {},
  updateVehicleTrackingForOutward: {},
  packTypeForDeliveryLineItem: {},
  createVehicleTrackingLoadHeader: {},
  vehicleTrackingAttachedLoads: [],
  updateVehicleTrackingLoadLineItem: {},
  updateVehicleTrackingLoad: {},
  vehicleTrackingLoadDetails: {},
  capturedWeightForWeightBridgeData: {},
  updateVehicleTrackingLoadWeight: {},
  loadLineItemsForVehicleTracking: null,
  confirmVehicleTrackingLoad: {},
  validateAndGetDuplicateObjectsForVehicleTracking: null,
  attachedDeliveriesForVehicleTracking: null,
  attachedDeliveryLineItemsForVehicleTracking: null,
  updateVehicleTrackingDeliveryAttachments: {},
  updateVehicleTrackingDetails: {},
  products: null,
  varianceOutwardReportList: [],
  outwardReportWithExitTimeList: [],
  updateVehicleTrackingStatus: {},
  reasonsDropdownOptionsForVehicleTracking: null,
};

const VehicleTrackingOutwardReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case GET_VEHICLE_DROPDOWN_OPTIONS:
      return {
        ...state,
        vehicleDropdownOptions: payload,
      };
    case RESET_VEHICLE_DROPDOWN_OPTIONS:
      return {
        ...state,
        vehicleDropdownOptions: [],
      };
    case CREATE_VEHICLE_TRACKING_OUTWARD:
      return {
        ...state,
        createOutward: payload,
      };
    case CREATE_DUPLICATE_VEHICLE_TRACKING:
      return {
        ...state,
        createDuplicateVehicleTracking: payload,
      };
    case GET_DELIVERY_FOR_BUSINESS_PARTNER:
      return {
        ...state,
        deliveryLineitemData: payload,
      };
    case RESET_DELIVERY_FOR_BUSINESS_PARTNER:
      return {
        ...state,
        deliveryLineitemData: {},
      };
    case GET_DELIVERY_DROPDOWN_OPTIONS:
      return {
        ...state,
        deliveryDropdownOptions: payload,
      };
    case RESET_DELIVERY_LIST_FOR_VEHICLE_NUMBER:
      return {
        ...state,
        deliveryDropdownOptions: {},
      };
    case GET_CATEGORY_BASED_BUSINESS_PARTNER:
      return {
        ...state,
        categoryBasedBusinessPartner: payload,
      };
    case GET_TRANSPORTER_DATA:
      return {
        ...state,
        transporterList: payload,
      };
    case GET_TRANSPORTER_DROPDOWN_OPTIONS:
      return {
        ...state,
        transporterDropdownOptions: payload,
      };
    case GET_ATTACHED_DELIVERY_FOR_OUTWARD_VEHICLE:
      return {
        ...state,
        attachedDeliveryForOutwardVehicle: payload,
      };
    case RESET_ATTACHED_DELIVERY_FOR_OUTWARD_VEHICLE:
      return {
        ...state,
        attachedDeliveryForOutwardVehicle: [],
      };
    case GET_VEHICLE_DETAILS_FOR_OUTWARD:
      return {
        ...state,
        vehicleDetailsForOutward: payload,
      };
    case GET_VEHICLE_TRACKINGS_FOR_VEHICLE_DETAIL:
      return {
        ...state,
        vehicleTrackingsForVehicleDetail: {
          ...state.vehicleTrackingsForVehicleDetail,
          [payload.status]: payload.data,
        },
      };
    case RESET_VEHICLE_DETAILS:
      return {
        ...state,
        vehicleDetailsForOutward: {},
        vehicleTrackingsForVehicleDetail: {},
      };
    case GET_VEHICLE_TRACKING_LIST_FOR_PLANNING:
      return {
        ...state,
        vehicleTrackingListForPlanning: payload,
      };
    case GET_OUTWARD_VEHICLE_TRACKING_DETAILS:
      return {
        ...state,
        outwardVehicleTrackingDetails: payload,
      };
    case RESET_OUTWARD_VEHICLE_TRACKING_DETAILS:
      return {
        ...state,
        outwardVehicleTrackingDetails: {},
      };
    case UPDATE_VEHICLE_TRACKING_FOR_OUTWARD:
      return {
        ...state,
        updateVehicleTrackingForOutward: payload,
      };
    case GET_PACK_TYPE_FOR_DELIVERY_LINE_ITEM:
      return {
        ...state,
        packTypeForDeliveryLineItem: payload,
      };
    case RESET_GET_PACK_TYPE_FOR_DELIVERY_LINE_ITEM:
      return {
        ...state,
        packTypeForDeliveryLineItem: null,
      };
    case CREATE_VEHICLE_TRACKING_LOAD_HEADER:
      return {
        ...state,
        createVehicleTrackingLoadHeader: payload,
      };
    case GET_VEHICLE_TRACKING_ATTACHED_LOADS:
      return {
        ...state,
        vehicleTrackingAttachedLoads: payload,
      };
    case GET_LOAD_LINE_ITEMS_FOR_LOAD_HEADER:
      return {
        ...state,
        loadLineItemsForLoadHeader: payload,
      };
    case UPDATE_VEHICLE_TRACKING_LOAD_LINE_ITEM:
      return {
        ...state,
        updateVehicleTrackingLoadLineItem: payload,
      };
    case UPDATE_VEHICLE_TRACKING_LOAD:
      return {
        ...state,
        updateVehicleTrackingLoad: payload,
      };
    case GET_DATA_FOR_VEHICLE_TRACKING_LOAD_CARDS:
      return {
        ...state,
        vehicleTrackingLoadDetails: payload,
      };
    case GET_CAPTURED_WEIGHT_FOR_WEIGHT_BRIDGE_EVENT_UUID:
      return {
        ...state,
        capturedWeightForWeightBridgeData: payload,
      };
    case UPDATE_VEHICLE_TRACKING_LOAD_WEIGHT:
      return {
        ...state,
        updateVehicleTrackingLoadWeight: payload,
      };
    case GET_LOAD_LINE_ITEMS_FOR_VEHICLE_TRACKING:
      return {
        ...state,
        loadLineItemsForVehicleTracking: payload,
      };
    case CONFIRM_VEHICLE_TRACKING_LOAD:
      return {
        ...state,
        confirmVehicleTrackingLoad: payload,
      };
    case UPDATE_VEHICLE_TRACKING_ON_HOLD:
      return {
        ...state,
        updateVehicleTrackingOnHold: payload,
      };
    case VALIDATE_AND_GET_DUPLICATE_OBJECTS_FOR_VEHICLE_TRACKING:
      return {
        ...state,
        validateAndGetDuplicateObjectsForVehicleTracking: payload,
      };
    case GET_ATTACHED_DELIVERIES_FOR_VEHICLE_TRACKING:
      return {
        ...state,
        attachedDeliveriesForVehicleTracking: payload,
      };
    case GET_ATTACHED_DELIVERY_LINE_ITEMS_FOR_VEHICLE_TRACKING:
      return {
        ...state,
        attachedDeliveryLineItemsForVehicleTracking: payload,
      };
    case UPDATE_VEHICLE_TRACKING_DELIVERY_ATTACHMENTS:
      return {
        ...state,
        updateVehicleTrackingDeliveryAttachments: payload,
      };
    case UPDATE_VEHICLE_TRACKING_DETAILS:
      return {
        ...state,
        updateVehicleTrackingDetails: payload,
      };
    case GET_PRODUCTS:
      return {
        ...state,
        products: payload,
      };
    case GET_VARIANCE_REPORT_FOR_OUTWARD:
      return {
        ...state,
        varianceOutwardReportList: payload,
      };
    case GET_OUTWARD_REPORT_WITH_EXIT_TIME:
      return {
        ...state,
        outwardReportWithExitTimeList: payload,
      };
    case UPDATE_VEHICLE_TRACKING_STATUS:
      return {
        ...state,
        updateVehicleTrackingStatus: payload,
      };

    case GET_REASONS_DROPDOWN_OPTIONS_FOR_VEHICLE_TRACKING:
      return {
        ...state,
        reasonsDropdownOptionsForVehicleTracking: payload,
      };
    default:
      return state;
  }
};
export default VehicleTrackingOutwardReducer;
